import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainerStyle: {
      padding: theme.spacing(3),
      paddingBottom: 0,
      backgroundColor: theme.palette.background.paper,
    },
    contentContainer: {
      position: 'relative',
      margin: theme.spacing(3),
      marginTop: theme.spacing(1.75),
    },
  }),
);
